import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = props => {    
    const contentLinks = useSelector((state) => state.navigation.contentLinks);

    return <NavigationItem links={contentLinks} directLinkList={props.directLinkList} isStoreWebsite={props.isStoreWebsite} eyeHealthClinicLink={props.eyehealthCliniclink}/>;
};

export default Navigation;
